import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mantine/core';

import { SECONDARY_PRICES, MENU_OBJECT_TYPES } from 'constants/menuManagement';
import { useMenuManagement } from 'hooks/useMenuManagement';
import { useTranslation } from 'i18n';

import { PriceInput } from 'components/MenuManagement/Fields/PriceInput';

const NS = 'menuManagementFields';

export default function PriceInputField({ form, title, dataIndex, record, isNewItem }) {
  const { t } = useTranslation(NS);
  const { singleMenu, checkParentMenuHasIntegration } = useMenuManagement();

  // Only show secondary price if this is used in
  // main item edit drawer or modifier edit drawer
  const showSecondaryPrice =
    dataIndex === 'price' &&
    checkParentMenuHasIntegration(Object.keys(SECONDARY_PRICES.apps), singleMenu) &&
    !isNewItem &&
    (record?.itemType === MENU_OBJECT_TYPES.items ||
      record?.itemType === MENU_OBJECT_TYPES.modifiers);

  if (dataIndex === SECONDARY_PRICES.key) return null;

  return (
    <Grid gutter="xs">
      <Grid.Col span={showSecondaryPrice ? 6 : 12}>
        <Box>
          <PriceInput
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...form.getInputProps(dataIndex)}
            label={title}
            required
            record={record}
            setPrice={value => {
              form.setFieldValue(dataIndex, value);
            }}
            priceType={dataIndex}
          />
        </Box>
      </Grid.Col>
      {showSecondaryPrice && (
        <Grid.Col span={6}>
          <Box>
            <PriceInput
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...form.getInputProps(SECONDARY_PRICES.key)}
              label={t('PriceInputField.pickupPriceLabel')}
              record={record}
              setPrice={value => {
                form.setFieldValue(SECONDARY_PRICES.key, value);
              }}
              priceType={SECONDARY_PRICES.key}
            />
          </Box>
        </Grid.Col>
      )}
    </Grid>
  );
}

PriceInputField.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  title: PropTypes.string,
  dataIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // eslint-disable-next-line react/forbid-prop-types
  record: PropTypes.object,
  isNewItem: PropTypes.bool,
};
